<div class="modal-header">
    <div class="title">
        <h2 class="modal-title" *ngIf="selectedTabIndex === 'expedition'">Temps d'expédition</h2>
        <h2 class="modal-title" *ngIf="selectedTabIndex === 'livraison'">Estimation de la livraison</h2>
        <h3 class="modal-title">{{ order.parentId }}</h3>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body d-flex flex-column ">
    <div class="card-body mutliple-datepicker">
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab  *ngIf="order.status !== 'shipped'" label="Expédition">
                <ngb-datepicker #dp (select)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t"
                    outsideDays="hidden" [markDisabled]="isDisabled">
                </ngb-datepicker>
                <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
            </mat-tab>
            <mat-tab label="Livraison">
                <ngb-datepicker #dp (select)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t"
                    outsideDays="hidden" [markDisabled]="isDisabled">
                </ngb-datepicker>
                <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <!-- <hr>
        <span class="">entre le {{ fromDateFormated | date:'fullDate' }} </span>
        <span class="">et le {{ toDateFormated | date:'fullDate' }} </span> -->
    </div>
</div>

<div *ngIf="displayFooterBtn" class="modal-footer d-flex flex-row flex-jc-sa">
    <button type="reset" class="btn_bo btn btn-danger btn_bo" (click)="cancelDates()">Annuler</button>
    <button type="button" class="btn_bo btn btn-success btn_bo"
        (click)="validateDates(selectedTabIndex)">Valider</button>
</div>